import { $ } from './utils/dom.js';

export function createAppShell() {
  const app = $('#app');
  app.innerHTML = `
    <div class="app-shell">
      <header class="mobile-header" id="mobile-header">
        <button class="hamburger-btn" id="hamburger-btn" aria-label="Toggle navigation" aria-expanded="false">
          <span class="hamburger-icon"></span>
        </button>
        <span class="mobile-header-title">Condor for the Common Man</span>
      </header>
      <div class="sidebar-backdrop" id="sidebar-backdrop"></div>
      <aside class="app-sidebar" id="app-sidebar"></aside>
      <main class="app-content">
        <div class="app-page" id="page-content"></div>
        <footer class="app-footer">
          Questions, comments, concerns? Email
          <a href="mailto:condorforthecommonman@gmail.com">condorforthecommonman@gmail.com</a>
        </footer>
      </main>
    </div>
  `;

  return {
    sidebarContainer: $('#app-sidebar'),
    contentContainer: $('#page-content')
  };
}
